/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerDownloadQueryResponse, ComparisonsControllerDownloadPathParams, ComparisonsControllerDownload400, ComparisonsControllerDownload401, ComparisonsControllerDownload403, ComparisonsControllerDownload404 } from "../../models/comparisonsController/ComparisonsControllerDownload";

function getComparisonsControllerDownloadUrl(id: ComparisonsControllerDownloadPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/comparisons/${id}/download` as const }  
  return res
}

/**
 * @summary Download comparison PDF (streams bytes or redirects to S3 for legacy comparisons)
 * {@link /api/v1/comparisons/:id/download}
 */
export async function comparisonsControllerDownload(id: ComparisonsControllerDownloadPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ComparisonsControllerDownloadQueryResponse, ResponseErrorConfig<ComparisonsControllerDownload400 | ComparisonsControllerDownload401 | ComparisonsControllerDownload403 | ComparisonsControllerDownload404>, unknown>({ method : "GET", url : getComparisonsControllerDownloadUrl(id).url.toString(), ... requestConfig })  
  return res.data
}